/**
 * @generated SignedSource<<5dc1b7578fcbfb56f13766b55c4634b5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type videoPrimaryContent$data = {
  readonly entityId: string;
  readonly headline: string | null | undefined;
  readonly image: {
    readonly style: {
      readonly url: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly sectionsV2: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly name?: string;
      readonly " $fragmentSpreads": FragmentRefs<"entityLink" | "helpersCheckIfNewsSectionInFirstIndexSection">;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly socialHeadline: string | null | undefined;
  readonly topics: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"topicLinkTopic">;
  } | null | undefined> | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"actionWidgetContent" | "entityLink" | "helpersGetVideoYoutubeIdVideo" | "shareArticle20Content">;
  readonly " $fragmentType": "videoPrimaryContent";
};
export type videoPrimaryContent$key = {
  readonly " $data"?: videoPrimaryContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"videoPrimaryContent">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
],
v1 = {
  "kind": "InlineFragment",
  "selections": (v0/*: any*/),
  "type": "VideoSection",
  "abstractKey": null
},
v2 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "entityLink"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "videoPrimaryContent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "headline",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "socialHeadline",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "type": "MAIN_IMAGE"
          }
        }
      ],
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "image",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "style": "wide_landscape"
              }
            }
          ],
          "concreteType": "ImageStyle",
          "kind": "LinkedField",
          "name": "style",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            }
          ],
          "storageKey": "style(filter:{\"style\":\"wide_landscape\"})"
        }
      ],
      "storageKey": "image(filter:{\"type\":\"MAIN_IMAGE\"})"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SectionSegmentV2",
      "kind": "LinkedField",
      "name": "sectionsV2",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "value",
          "plural": true,
          "selections": [
            (v1/*: any*/),
            {
              "kind": "InlineDataFragmentSpread",
              "name": "helpersCheckIfNewsSectionInFirstIndexSection",
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": (v0/*: any*/),
                  "type": "Section",
                  "abstractKey": null
                },
                (v1/*: any*/)
              ],
              "args": null,
              "argumentDefinitions": []
            },
            (v2/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Topic",
      "kind": "LinkedField",
      "name": "topics",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "topicLinkTopic"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "actionWidgetContent"
    },
    (v2/*: any*/),
    {
      "kind": "InlineDataFragmentSpread",
      "name": "helpersGetVideoYoutubeIdVideo",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "youtubeId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "VideoSource",
          "kind": "LinkedField",
          "name": "videoSource",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "type",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "shareArticle20Content"
    }
  ],
  "type": "Video",
  "abstractKey": null
};
})();

(node as any).hash = "9888f0c115d1b8e1750e41dca9aea50c";

export default node;
